import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  linked: false,
  membershipId: "",
  partnerLogoUrl: "",
  partnerId: "",
  partnerName: "",
};

/**
 * Slice for managing web feature controls state.
 * Includes reducers for fetching controls, setting controls, and handling errors.
 *
 * @type {import("@reduxjs/toolkit").Slice}
 */
export const PartnerInfoSlice = createSlice({
  name: "partnerInfo",
  initialState,
  reducers: {
    requestToGetPartnerInfo: (state) => {
      return {
        ...state,
      };
    },
    requestToSetPartnerInfoSuccess: (state, action) => {
      return {
        ...state,
        linked: action.payload.linked,
        membershipId: action.payload.membershipId,
        partnerLogoUrl: action.payload.partnerLogoUrl,
        partnerId: action.payload.partnerId,
        partnerName: action.payload.partnerName,
      };
    },
    requestToSetPartnerInfoFailure: (state) => {
      return {
        ...state,
        linked: false,
        membershipId: "",
        partnerLogoUrl: "",
        partnerId: "",
        partnerName: "",
      };
    },
  },
});

export const { requestToGetPartnerInfo, requestToSetPartnerInfoSuccess, requestToSetPartnerInfoFailure } =
  PartnerInfoSlice.actions;

export default PartnerInfoSlice.reducer;
